import { render, staticRenderFns } from "./our-side.vue?vue&type=template&id=76f1870c"
import script from "./our-side.vue?vue&type=script&lang=js"
export * from "./our-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports